import React from 'react';
import { deviceStatusText } from '../utils/presence';

// 기기 모양 아이콘 (상태 색으로 채움): PC 모니터 / 태블릿 / 휴대폰
const PATHS = {
    desktop: <><rect x="2" y="3" width="20" height="13" rx="2" /><path d="M9 20h6M12 16v4" strokeLinecap="round" /></>,
    tablet: <><rect x="4" y="2" width="16" height="20" rx="2.5" /><circle cx="12" cy="18.5" r="0.9" className="presence-icon-dot" /></>,
    phone: <><rect x="7" y="2" width="10" height="20" rx="2.5" /><path d="M11 18.5h2" strokeLinecap="round" /></>,
};

export function DeviceIcon({ device, status, active, size = 14 }) {
    return (
        <svg className={`presence-icon status-${status}${status === 'dnd' && !active ? ' away' : ''}`} width={size} height={size}
            viewBox="0 0 24 24" fill="none" strokeWidth="2.2" role="img" aria-label={deviceStatusText({ device, status, active })}>
            <title>{deviceStatusText({ device, status, active })}</title>
            {PATHS[device] || PATHS.desktop}
        </svg>
    );
}

export function DeviceIcons({ devices = [], size }) {
    if (!devices.length) return null;
    return (
        <span className="presence-devices">
            {devices.map(d => <DeviceIcon key={d.device} {...d} size={size} />)}
        </span>
    );
}
